export const HEADER_NAME_API_VERSION = 'X-API-VERSION';
export const HEADER_NAME_ORIGINAL_USERID = 'X-AUTH-ORIGINAL-USERID';

/**
 * Stable, low-cardinality client identifier required by krill-base-api on all
 * /api/* requests (X-CLIENT-ID).
 * See https://whalar.atlassian.net/wiki/spaces/sab/pages/7272190574610
 */
export const X_CLIENT_ID = 'krill-web-client';
